import { TbCheck } from "react-icons/tb";

export default function Checkbox({ className = "", ...props }) {
    return (
        <>
            <input
                {...props}
                type="checkbox"
                name={props.name}
                id={props.name}
                className="hidden peer"
            />
            <label
                htmlFor={props.name}
                className={
                    "rounded p-0.5 block w-max transition-colors border-gray-300 bg-white border peer-checked:border-[#2f2f2f] peer-checked:bg-[#2f2f2f] text-white shadow-sm " +
                    className
                }
            >
                <TbCheck strokeWidth={3} className="w-3.5 h-3.5" />
            </label>
        </>
    );
}
